(function() {
  'use strict';
  
  // Initialize gallery slider
  function initGallerySlider() {
    const wrapper = document.querySelector('.architectural-stone-gallery-wrapper');
    if (!wrapper) return;
    
    const track = wrapper.querySelector('.architectural-stone-gallery-track');
    const slides = Array.from(track.querySelectorAll('.architectural-stone-gallery-slide'));
    const prevBtn = wrapper.querySelector('.architectural-stone-gallery-prev');
    const nextBtn = wrapper.querySelector('.architectural-stone-gallery-next');
    const dotsContainer = document.querySelector('.architectural-stone-gallery-dots');
    
    if (!track || slides.length === 0) return;
    
    let currentIndex = 0;
    let slidesPerView = window.innerWidth >= 768 ? 2 : 1;
    const totalSlides = slides.length;
    const maxIndex = Math.max(0, totalSlides - slidesPerView);
    
    // Create dots
    function createDots() {
      dotsContainer.innerHTML = '';
      const numDots = maxIndex + 1;
      
      for (let i = 0; i <= maxIndex; i++) {
        const dot = document.createElement('button');
        dot.className = 'architectural-stone-gallery-dot';
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        if (i === 0) dot.classList.add('active');
        
        dot.addEventListener('click', () => goToSlide(i));
        dotsContainer.appendChild(dot);
      }
    }
    
    // Update slider position
    function updateSlider() {
      const slideWidth = slides[0].offsetWidth;
      const gap = 20;
      const offset = -(currentIndex * (slideWidth + gap));
      
      track.style.transform = `translateX(${offset}px)`;
      
      // Update dots
      const dots = dotsContainer.querySelectorAll('.architectural-stone-gallery-dot');
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === currentIndex);
      });
      
      // Update button states
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= maxIndex;
    }
    
    // Go to specific slide
    function goToSlide(index) {
      currentIndex = Math.max(0, Math.min(index, maxIndex));
      updateSlider();
    }
    
    // Navigation handlers
    prevBtn.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateSlider();
      }
    });
    
    nextBtn.addEventListener('click', () => {
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateSlider();
      }
    });
    
    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const newSlidesPerView = window.innerWidth >= 768 ? 2 : 1;
        
        if (newSlidesPerView !== slidesPerView) {
          slidesPerView = newSlidesPerView;
          const newMaxIndex = Math.max(0, totalSlides - slidesPerView);
          
          // Adjust current index if needed
          if (currentIndex > newMaxIndex) {
            currentIndex = newMaxIndex;
          }
          
          createDots();
          updateSlider();
        } else {
          updateSlider();
        }
      }, 250);
    });
    
    // Keyboard navigation
    wrapper.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        prevBtn.click();
      } else if (e.key === 'ArrowRight') {
        nextBtn.click();
      }
    });
    
    // Initialize
    createDots();
    updateSlider();
    
    // Hide navigation if not enough slides
    if (totalSlides <= slidesPerView) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
      dotsContainer.style.display = 'none';
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallerySlider);
  } else {
    initGallerySlider();
  }
  
  // Reinitialize on Shopify theme editor changes
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initGallerySlider);
    document.addEventListener('shopify:section:reorder', initGallerySlider);
    document.addEventListener('shopify:block:select', initGallerySlider);
  }
})();